import React from "react";

import { Link } from "../../../common/Link";
import { IProduct } from "../../../models/catalogue.interfaces";
import { getOptionValueDisplayName } from "../../../utils/catalogue";
import { listOptions } from "./utils";

import styles from "./common.module.scss";

export const BasketLineTitle = (props: {
    product: IProduct;
    additionalCSSClass?: string;
}): React.ReactNode => {
    let title = props.product.parent
        ? props.product.parent.title
        : props.product.title;
    if (props.product.parent) {
        const titleOptions = listOptions(props.product)
            .filter((option) => option.key !== "option_color")
            .map((option) =>
                getOptionValueDisplayName(option.name, option.value),
            )
            .filter((name) => !!name)
            .join(", ");
        if (titleOptions) {
            title = title + ", " + titleOptions;
        }
    }
    return (
        <h2 className={`${styles.productTitle} ${props.additionalCSSClass}`}>
            <Link href={props.product.link} target="_top">
                {title}
            </Link>
        </h2>
    );
};
